import React from 'react';
import './Sidebar.scss';
import {useDispatch} from "react-redux";
import logo from "../assets/images/logo-no-text.png"
import {Link, useNavigate, useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {LOGOUT} from "../store/auth/actions/auth-actions";

const Sidebar = ({onClick}) => {

    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch()

    const isActive = (path) => {
        if (path === '/orders') {
            return location.pathname.startsWith('/orders');
        }
        if (path === '/calculations') {
            return location.pathname.startsWith('/calculations');
        }
        if (path === '/boards') {
            return location.pathname.startsWith('/boards');
        }
        return location.pathname === path;
    };

    function handleLogoutClick() {
        dispatch({type: LOGOUT})
    }

    function handleOnClick(e) {
        onClick(e.currentTarget.getAttribute('translation-key'))
    }
    
    function handleOrdersClick(e) {
        e.preventDefault();
        onClick('sideBar.orders');
        // Force navigation to clean /orders path (clears any URL params)
        navigate('/orders', { replace: true });
    }

    function handleChangeLanguage(e) {
        let lng = e.currentTarget.getAttribute('data-language');
        i18n.changeLanguage(lng);
    }

    return (
        <div className="sidebar">
            <div className="logo">
                <img src={logo} alt="Company Logo"/>
            </div>
            <nav className="menu">
                <ul>
                    <li className={isActive('/dashboard') ? 'active' : ''}><Link to="/dashboard" onClick={handleOnClick}
                              translation-key="sideBar.dashboard">{t(`sideBar.dashboard`)}</Link></li>
                    <li className={isActive('/orders') ? 'active' : ''}><Link to="/orders" onClick={handleOrdersClick} replace={true}
                              translation-key="sideBar.orders">{t(`sideBar.orders`)}</Link></li>
                    <li className={isActive('/customers') ? 'active' : ''}><Link to="/customers" onClick={handleOnClick}
                              translation-key="sideBar.customers">{t(`sideBar.customers`)}</Link></li>
                    <li className={isActive('/product') ? 'active' : ''}><Link to="/product" onClick={handleOnClick}
                              translation-key="sideBar.products">{t(`sideBar.products`)}</Link></li>
                    <li className={isActive('/news') ? 'active' : ''}><Link to="/news" onClick={handleOnClick}
                              translation-key="sideBar.news">{t(`sideBar.news`)}</Link></li>
                    <li className={isActive('/calculations') ? 'active' : ''}><Link to="/calculations" onClick={handleOnClick}
                              translation-key="sideBar.calculations">{t(`sideBar.calculations`)}</Link></li>
                    <li className={isActive('/boards') ? 'active' : ''}><Link to="/boards" onClick={handleOnClick}
                              translation-key="sideBar.boards">{t(`sideBar.boards`)}</Link></li>
                    <li className={isActive('/financial') ? 'active' : ''}><Link to="/financial" onClick={handleOnClick}
                              translation-key="sideBar.financial">{t(`sideBar.financial`)}</Link></li>

                    <li><Link to="#" onClick={handleLogoutClick}>{t(`sideBar.logout`)}</Link></li>
                    <br/>
                    <li data-language="rs" onClick={handleChangeLanguage}>
                        RS
                    </li>
                    <li data-language="en" onClick={handleChangeLanguage}>
                        EN
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default Sidebar;
